import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import AppLink from './components/AppLink';
import SectionHeader from './components/SectionHeader';
import PlatformSection from './components/PlatformSection';

import { getDownloadPcLink } from './request';
import { PlatformSectionConfig } from './config';
import './style.scss';

const Platform: React.FC = () => {
    const {
        header: { appLink },
        section
    } = PlatformSectionConfig;

    const [platformConfig, setPlatformConfig] = useState(appLink);

    useEffect(() => {
        const getData = async () => {
            try {
                const res = await Promise.all([getDownloadPcLink('darwin'), getDownloadPcLink('win32')]);

                const newConfig = JSON.parse(JSON.stringify(platformConfig));
                const macDownloadUrl = res[0].downloadUrl;
                const winDownloadUrl = res[1].downloadUrl;

                newConfig.forEach(item => {
                    if (macDownloadUrl && item.type === 'mac') {
                        item.url = macDownloadUrl;
                    }

                    if (winDownloadUrl && item.type === 'win') {
                        item.url = winDownloadUrl;
                    }
                });

                setPlatformConfig(newConfig);
            } catch {}
        };

        getData();
        // eslint-disable-next-line
    }, []);

    return (
        <div className="plarform-root">
            <Helmet>
                <title>Cutting Edge Stock Trading Platforms by TradeUP</title>
                <meta
                    name="description"
                    content="TradeUP's online trading platform provides a wide array of tools and resources for you to trade with ease. You can keep tabs on the market, place orders, and monitor your positions all in one place!"
                />
            </Helmet>
            <header className="platform-header">
                <div className="flex-1"></div>
                <div className="header-content">
                    <div>Invest Anywhere Anytime </div>
                    <div className="header-content-long">
                        <span>We’re Adding More Value to </span>
                        <span>$0 Commission </span>
                    </div>
                </div>
                <div className="applink-container">
                    {platformConfig.map(item => {
                        const { type, imgSrc, url } = item;

                        return <AppLink key={type} type={type} imgSrc={imgSrc} url={url} className="applink-item" />;
                    })}
                </div>
                <p className="header-content-explain">
                    $0.00 commission applies to online U.S. equity trades and exchange-traded funds (ETFs) in a TradeUP
                    retail account only for TradeUP Securities, Inc. retail clients. Sell orders are subject to an
                    activity assessment fee. Other exclusions and conditions may apply. See{' '}
                    <a href="https://www.tradeup.com/pricing/commissions-us">
                        https://www.tradeup.com/pricing/commissions-us
                    </a>{' '}
                    for details. Institutional accounts, OTC securities trading and other types of high-touch services
                    are subject to different commission schedules.
                </p>
            </header>
            <article className="platform-article">
                {section.map(item => {
                    const { header, imgSrc } = item;

                    if (!imgSrc) {
                        return <SectionHeader key={header} {...item} />;
                    }

                    return <PlatformSection key={header} {...item} />;
                })}
            </article>
            <div></div>
        </div>
    );
};

export default Platform;
